<div class="row pl-3 pb-2 w-100 cursor-default">
    <div class="col pl-0">   
        <h6 class="f-15 font-weight-light">{{ 'customeruserlist.title' | trans }}</h6>
    </div>
</div>
<div class="row mb-1 cursor-default">
   <div class="col-5 col-md">
       <p class="mb-0 font-weight-lighter lh-24 align-middle">{{ 'customeruserlist.name' | trans }}</p>
   </div>
  <div class="col-3 d-none d-sm-block">
    <p class="mb-0 font-weight-lighter lh-24 align-middle d-none d-sm-block d-md-none d-lg-block">{{ 'customeruserlist.userstate' | trans }}</p>
  </div>
   <div class="col-5 col-md-3 pl-3">
    <p class="mb-0 font-weight-lighter lh-24 align-middle">{{ 'customeruserlist.username' | trans }}</p>
  </div>
  <div class="col-1 pr-2"></div>
</div>
<div *ngFor="let user of userlist">
<div class="row user-list-row pl-3 hoverrow cursor-pointer">
   <div class="col-5 col-md pl-0 d-grid">
       <p class="mb-0 hover-group lh-25 align-middle text-truncate">{{ user.fullname }}</p>
   </div>
   <div class="col-3 pl-1 d-none d-sm-block d-md-none d-lg-block d-grid" >
    <p class="mb-0 hover-group lh-25 align-middle text-truncate">{{ user.isactive == true ? 'Active' : 'Not active' }}</p>
   </div>
   <div class="col-5 col-md-3 pl-1 pl-md-2 d-grid">
    <p class="mb-0 hover-group lh-25 align-middle text-truncate">{{ user.username }}</p>
   </div>
   <div class="col- pr-2">
    <span *ngIf="canAddEditDelete()"  data-toggle="modal" data-target="#deletecustomeruser" (click)="confirmDelete(user)" class="material-icons vs-toggler opacity cursor-pointer lh-25 align-middle f-18 p-0 rounded-circle transition">
        delete
        </span>    
    </div>
    <div class="col- pr-1">
        <span *ngIf="canAddEditDelete()"  data-toggle="modal" (click)="setEditUser(user)" data-target="#editcustomeruser"class="material-icons vs-toggler opacity cursor-pointer lh-25 align-middle f-18 p-0 rounded-circle transition">
            create
            </span>    
        </div>
</div>
</div>
<div class="mb-2 container-fluid"></div>

<!-- Modal delete customer user-->
<div class="modal fade" id="deletecustomeruser" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" >{{ 'customeruserlist.deletecustomeruser' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
                <p class="text-center">{{ 'customeruserlist.deletecustomeruserconfirm' | trans }}{{ userToDelete?.fullname }}</p>
            </div>
        </div>
    <div class="row">
      <div class="col">
        <button data-dismiss="modal" class="btn-close"><h6 class="btn-save-text">{{ 'customeruserlist.close' | trans }}</h6></button>
    </div>
        <div class="col">
            <button (click)="deleteUser()" data-dismiss="modal" class="btn-save"><h6 class="btn-save-text">{{ 'customeruserlist.confirmdelete' | trans }}</h6></button>
        </div>
    </div>
        </div>
      </div>
    </div>
  </div>
    <!-- Modal edit customer user-->
    <div class="modal fade" id="editcustomeruser" tabindex="-1" role="dialog" >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">{{ 'customeruserlist.editcustomeruser' | trans }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span >&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <app-customeruseredit (changeduser)="changedUser" [user]="user"></app-customeruseredit>
            </div>
          </div>
        </div>
      </div>